import React from "react";

import { Link } from "@rui/Link";
import { Row } from "@rui/Stack";
import Stepper from "@rui/Stepper";

import { Action } from "./styles";

export interface UpsellModuleActionsProps {
  cta?: {
    label: string;
    href?: string;
    to?: string;
    onClick?: () => void;
    disabled?: boolean;
  };
  onDismiss?: () => void;
  slides?: {
    activeSlide: number;
    count: number;
    jumpToSlide: (index: number) => void;
  };
}

const UpsellModuleActions = ({
  cta,
  onDismiss,
  slides,
}: UpsellModuleActionsProps) => {
  if (!cta && !onDismiss && !slides) return null;
  return (
    <Row variant="apart" spacing={1} zIndex={1}>
      <Row variant="left" spacing={0.5}>
        {cta && (
          <Link to={cta.to} href={cta.href} onClick={cta.onClick}>
            <Action variant="outlined" disabled={Boolean(cta?.disabled)}>
              {cta.label}
            </Action>
          </Link>
        )}
        {onDismiss && <Action onClick={onDismiss}>Dismiss</Action>}
      </Row>
      {slides && (
        <Stepper
          activeStepColor="shades.primary.500"
          inactiveStepColor="transparent.black.12"
          activeStepWidth="34px"
          activeStep={slides.activeSlide}
          onClickStep={slides.jumpToSlide}
          steps={slides.count}
          sx={{ m: "2px" }}
        />
      )}
    </Row>
  );
};

export default UpsellModuleActions;
